module.exports = "https://assets.pclncdn.com/web/next-landing/03c4f86f87/_next/static/images/pcln-hp-hero-sunset-bb23f22ff8eb6ed3e694b3489241ff0b.png";